
import { Component } from "vue-property-decorator";
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
import Calendar from "@/components/Calender.vue";
import ReservationModule from "@/store/reservation";
import HospitalModule from "@/store/hospital";
import FacilityService from "@/services/facilities";
import CheckCommonLogin from "@/utils/CheckCommonLogin";
import { InformationData } from "@/@types/information";
import moment from "moment";

@Component({
  name: "DateSelect",
  components: {
    Header,
    Footer,
    Calendar,
  },
})
export default class DateSelect extends CheckCommonLogin {
  private get selectedCourse() {
    return ReservationModule.selectedCourse;
  }

  private get hospitalId() {
    return HospitalModule.hospitalId;
  }

  private get readNotices() {
    return HospitalModule.readNotices;
  }

  private hospitalData = null;

  private noticeList: InformationData[] = [];
  private unreadNotices: InformationData[] = [];

  private dontShowAgain = false;
  private modalHeight = "auto";

  private noticeDateFactory(time: string) {
    return moment(new Date(time).toISOString()).format("YYYY/MM/DD");
  }

  private mounted() {
    this.getHospitalData();
    this.getNotices();
  }

  private async getHospitalData() {
    const res = await FacilityService.getHospital(this.hospitalId);
    this.hospitalData = res.data.data[0];
  }

  private async getNotices() {
    const res = await FacilityService.getHospitalNoticeList(this.hospitalId);
    const now = moment(new Date().toISOString());
    const filteredPublicNoticeList: InformationData[] = res.data.data.filter((notice: InformationData) => {
      const startDate = moment(new Date(notice.start_datetime).toISOString());
      const endDate = notice.end_datetime ? moment(new Date(notice.end_datetime).toISOString()) : null;
      if (endDate) {
        return now.isAfter(startDate) && now.isBefore(endDate);
      }
      return now.isAfter(startDate);
    });

    // 降順にソート
    filteredPublicNoticeList.sort((x, y) => {
      const firstDate = new Date(x.start_datetime);
      const secondDate = new Date(y.start_datetime);

      if (firstDate < secondDate) return -1;
      if (firstDate > secondDate) return 1;
      return 0;
    });

    this.noticeList = filteredPublicNoticeList;

    // 未読のお知らせをフィルタリング - ポップアップ表示がtrueかつ未読のもののみ
    this.unreadNotices = this.noticeList.filter((notice) => {
      // popupがtrueかつ未読のお知らせのみをポップアップ対象とする
      return notice.popup && this.isNoticeUnread(notice);
    });

    // 未読があればポップアップを表示
    if (this.unreadNotices.length > 0) {
      this.$modal.show("noticeModal");
      // モーダル表示後にコンテンツの高さをチェック
      this.$nextTick(() => {
        this.checkModalContentHeight();
      });
    }
  }

  /**
   * モーダルコンテンツの高さをチェックし、必要に応じてモーダルの高さを設定する
   */
  private checkModalContentHeight() {
    this.$nextTick(() => {
      const contentEl = this.$refs.noticeModalContent as HTMLElement;
      if (contentEl) {
        // スクロールの高さが280pxを超える場合は固定高さを設定
        if (contentEl.scrollHeight > 280) {
          this.modalHeight = "550px";
        } else {
          this.modalHeight = "auto";
        }
      }
    });
  }

  /**
   * お知らせが未読かどうかを確認する
   * @param notice お知らせ情報
   * @returns 未読ならtrue、既読ならfalse
   */
  private isNoticeUnread(notice: InformationData): boolean {
    if (!this.readNotices) return true;
    // お知らせIDが一致する既読レコードを探す
    const readNotice = this.readNotices.find((n) => n.id === notice.id);
    // 既読レコードが見つからない場合は未読
    if (!readNotice) return true;

    // お知らせが更新されている場合は既読日時と更新日時を比較
    if (notice.updated_at) {
      const readAt = new Date(readNotice.readAt);
      const updatedAt = new Date(notice.updated_at);
      // 更新日時が既読日時より新しい場合は未読と判断
      return updatedAt > readAt;
    }

    // 既読レコードが見つかり、更新日時がない場合は既読
    return false;
  }

  private closeNoticeModal() {
    this.$modal.hide("noticeModal");
  }

  private closeWithCheck() {
    if (this.dontShowAgain) {
      // 全ての未読お知らせを既読にする
      for (const notice of this.unreadNotices) {
        HospitalModule.markNoticeAsRead(notice.id);
      }
    }
    // ポップアップを閉じる
    this.closeNoticeModal();
  }
}
